<svg xmlns="http://www.w3.org/2000/svg" class="icon" [ngClass]="'icon ' + iconCls" viewBox="0 0 11.667 16.229">
	<path
		class="icon__path"
		d="M103.408,417.563a38.61,38.61,0,0,0-4.371-7.19c-.344-.46-.539-.7-.9-.7-.382,0-.53.228-.943.76a36.316,36.316,0,0,0-4.321,7.134,5.829,5.829,0,1,0,10.538,0Zm-5.453,5.651a1.043,1.043,0,0,1-1.407.435,3.613,3.613,0,0,1-1.871-2.246,6.325,6.325,0,0,1,.842-4.425l.676-1.148c.419-.6.8-.732,1.314-.474s.125.881-.135,1.394l-.559,1.241a4.706,4.706,0,0,0-.127,2.859,1.52,1.52,0,0,0,.833.956A1.042,1.042,0,0,1,97.956,423.213Z"
		transform="translate(-92.301 -409.668)"
	/>
</svg>
